import { z } from 'zod/v4';

import { LanguageEnumRuntype } from '../../utils/i18n';

export const BareSupplierContactDTORuntype = z.object({
    id: z.string(),
    is_main_contact: z.boolean(),
});

export interface SupplierContactDTO extends z.infer<typeof SupplierContactDTORuntype> {}
export const SupplierContactDTORuntype = z.object({
    id: z.string(),
    suppliers: z.array(BareSupplierContactDTORuntype),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    user_language: LanguageEnumRuntype,
    position: z.string().nullable(),
    phone_number: z.string().nullable(),
    is_public: z.boolean(),
});

const PhoneNumberInputRuntype = z.string().nullable().optional();

export interface SupplierContactCreationDTO extends z.infer<typeof SupplierContactCreationDTORuntype> {}
export const SupplierContactCreationDTORuntype = z.object({
    supplier: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    user_language: LanguageEnumRuntype,
    position: z.string().nullable(),
    phone_number: PhoneNumberInputRuntype,
    is_main_contact: z.boolean(),
});

export interface SupplierContactUpdateDTO extends z.infer<typeof SupplierContactUpdateDTORuntype> {}
export const SupplierContactUpdateDTORuntype = SupplierContactCreationDTORuntype.omit({
    supplier: true,
    email: true,
    is_main_contact: true,
})
    .partial()
    .and(
        z.object({
            relevant_supplier: z
                .object({
                    id: z.string(),
                    is_main_contact: z.boolean(),
                })
                .optional(),
        }),
    );

export interface ValidatedSupplierContactInsertDTO extends z.infer<typeof ValidatedSupplierContactInsertDTORuntype> {}
export const ValidatedSupplierContactInsertDTORuntype = SupplierContactDTORuntype.omit({
    id: true,
}).extend({
    phone_number: PhoneNumberInputRuntype,
});

export const SupplierContactToRemoveDTORuntype = z
    .object({
        id: z.string(),
        suppliers: z.array(z.string()),
    })
    .or(z.string().describe('Delete contact for all suppliers'));
